/**
 * Screen mixin
 *
 * Добавляет общую логику для всех экранов - показ ошибок/спиннера/благодарности
 *
 */

import BaseScreen from '@/components/BaseScreen.vue';
import BaseAlert from '@/components/BaseAlert.vue';

export default {
  components: {
    BaseScreen,
    BaseAlert,
  },
  data() {
    return {
      isPending: false,
      isPendingOverlayVisible: false,
      isThanksVisible: false,
      hasError: false,
    };
  },
  staticData: () => ({
    pendingTimeout: null,
  }),
  computed: {
    screen() {
      return {
        isPending: this.isPendingOverlayVisible,
        isHeaderHidden: this.isErrorVisible || this.isThanksVisible,
        isFooterHidden: !this.$route.meta.footer,
        pendingText: this.pendingText,
        title: this.title,
      };
    },
    isErrorVisible() {
      return this.hasError;
    },
  },
  beforeDestroy() {
    this.clearPendingTimeout();
  },
  methods: {
    clearPendingTimeout() {
      window.clearTimeout(this.pendingTimeout);
    },
    showPending(delay = 300) {
      // Показываем спиннер если операция не завершена за 300ms
      this.isPending = true;
      this.clearPendingTimeout();
      if (delay > 0) {
        this.pendingTimeout = window.setTimeout(() => {
          this.isPendingOverlayVisible = true;
        }, delay);
      } else {
        this.isPendingOverlayVisible = true;
      }
    },
    hidePending() {
      this.isPending = false;
      this.isPendingOverlayVisible = false;
      this.clearPendingTimeout();
    },
    showError() {
      this.hidePending();
      this.hasError = true;
      return this.sayError?.();
    },
    hideError() {
      this.hasError = false;
    },
    showThanks() {
      this.hidePending();
      this.isThanksVisible = true;
      return this.sayThanks?.();
    },
    hideThanks() {
      this.isThanksVisible = false;
    },
  },
};
